var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 5.924l1.822 1.052a8.551 8.551 0 011.371-1.783 8.57 8.57 0 016.09-2.522 8.569 8.569 0 016.09 2.522 8.568 8.568 0 011.845 2.739 8.51 8.51 0 01.678 3.35 8.567 8.567 0 01-2.522 6.09 8.568 8.568 0 01-6.09 2.522 8.563 8.563 0 01-4.202-1.091 8.66 8.66 0 01-3.258-3.216L2.5 16.641A10.712 10.712 0 0011.783 22C17.7 22 22.5 17.201 22.5 11.283 22.5 5.364 17.701.565 11.783.565 7.817.565 4.353 2.72 2.5 5.924z",
    fill: "#E2EADC"
  })));
}
export default SvgSpinner;